import moment from 'moment';

export const isDayBlockedLessonEdit = (date) => {
  const maxDate = moment()
  const minDate = moment().subtract(1, 'months')
  return !moment(date).isBetween(minDate, maxDate, 'days', '[]');
}



// WEBPACK FOOTER //
// ./src/containers/search/isDayBlocked.js